import { indexOrDie, singleOrDie, BigNumber } from "@repo/utils";
import type { ConfirmationLine, ScheduleLine } from "./comparison/types.js";
import { calculatePositionSplits } from "../../../erp/sap/patch/calculatePositionSplits.js";
import { compareScalars } from "./comparison/helpers.js";

export function calculateConfirmedSchedules(
    scheduleLines: ScheduleLine[],
    confirmations: ConfirmationLine[] | null,
    quantity: number | BigNumber | null,
) {
    if (scheduleLines.length === 0) {
        return [];
    }

    const split = singleOrDie(
        calculatePositionSplits(
            scheduleLines,
            confirmations ?? [],
            BigNumber.isBigNumber(quantity) ? quantity.toNumber() : (quantity ?? 0),
            false,
        ),
    );

    return split.map(({ scheduleIdx, confirmationIdx, quantity, split }) => {
        const scheduleLine = indexOrDie(scheduleLines, scheduleIdx);
        const confirmation = confirmationIdx !== null ? indexOrDie(confirmations ?? [], confirmationIdx) : null;

        const datapoints = {
            quantity: compareScalars(split ? null : BigNumber(scheduleLine.quantity), quantity, (a, b) => a.eq(b)),
            deliveryDate: compareScalars(
                split ? null : scheduleLine.deliveryDate,
                confirmation ? confirmation.deliveryDate : scheduleLine.deliveryDate,
            ),
            reference: confirmation?.reference ?? null,
        };

        return split
            ? {
                  result: "new",
                  orderId: null,
                  confirmationId: confirmationIdx,
                  datapoints,
              }
            : confirmationIdx !== null
              ? {
                    result: "matched",
                    orderId: scheduleIdx,
                    confirmationId: confirmationIdx,
                    datapoints,
                }
              : {
                    result: "missing",
                    orderId: scheduleIdx,
                    confirmationId: null,
                    datapoints,
                };
    });
}
